import { service } from '@ember/service';

import cannot from 'ember-can/helpers/cannot';
import { t } from 'ember-intl';
import { or } from 'ember-truth-helpers';

import Component from 'umg-ember-backend/components/record-detail/forms';
import ShopList from 'umg-ember-backend/components/shop-list';

export default class PageBuilderSettingsComponent extends Component {
  // Services
  @service permission;
  @service recordStatus;

  // Defaults
  templateOptions = [
    {
      value: 'standard',
      label: 'Standard',
    },
    {
      value: 'custom',
      label: 'Custom',
    },
  ];

  // Getter and setter
  get isModelDisabled() {
    return this.recordStatus.isDisabled(this.args.form.model);
  }

  // Template
  <template>
    <h2 class='u-margin-top-large'>
      {{t 'page_builder.settings.headline'}}
    </h2>

    <@form.fieldset @titleKey='customCode' as |fieldset|>
      <fieldset.field
        @property='options.customCSS'
        @type='code-editor'
        @codeFormat='css'
      />
      <fieldset.field
        @property='options.customHeader'
        @type='code-editor'
        @codeFormat='html'
      />
      {{#unless @form.model.isV2}}
        <fieldset.field
          @property='options.customJs'
          @type='code-editor'
          @codeFormat='javascript'
        />
      {{/unless}}
      {{yield}}
    </@form.fieldset>

    <@form.sections.seo />

    <@form.fieldset
      @titleKey='activeShops'
      @isClosed={{true}}
      @isVisible={{true}}
    >
      <ShopList
        @model={{@form.model}}
        @disabled={{or this.isModelDisabled (cannot 'update' @form.model)}}
      />
    </@form.fieldset>

    <@form.sections.meta />
  </template>
}
